import React, { useEffect } from 'react'
import Layout from './Layout'
import FormAddSensor from '../components/FormAddSensor'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice";

const AddSensor = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isError } = useSelector((state) => state.auth);

    useEffect(() => {
        dispatch(getMe());
    }, [dispatch]);

    useEffect(() => {
        if (isError) {
            navigate("/");
        }
    }, [isError, navigate]);

    const loggedInUser = localStorage.getItem("login");

    if (loggedInUser) {

        return (
            <Layout>
                <FormAddSensor />
            </Layout>
        )

    }
}

export default AddSensor